import React from 'react'
import { Box, Typography, Divider } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TechUsersView = ({ tech }) => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box>
        <Typography variant="subtitle2" component="div">작업 담당자</Typography>
        <Divider sx={{ my: 1 }} />
        <Box>
          {tech?.workEmp === undefined || tech?.workEmp === null ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="subtitle2" component="div">선택된 작업자가 없습니다.</Typography>
            </Box>
          ) : (
            <TableContainer component={Box}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>부서명</TableCell>
                    <TableCell>이름</TableCell>
                    <TableCell>직급</TableCell>
                    <TableCell>연락처</TableCell>
                    <TableCell>이메일</TableCell>
                    <TableCell>성별</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow >
                    <TableCell>{tech?.workEmpInf?.dptNm}</TableCell>
                    <TableCell>{tech?.workEmpInf?.usrNm}</TableCell>
                    <TableCell>{tech?.workEmpInf?.gradeNm}</TableCell>
                    <TableCell>{tech?.workEmpInf?.emlAddr}</TableCell>
                    <TableCell>{tech?.workEmpInf?.telNo}</TableCell>
                    <TableCell>{tech?.workEmpInf?.gender === 'M' ? '남성' : '여성'}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}

        </Box>
      </Box>

      <Box sx={{ my: 1 }}>
        <Typography variant="subtitle2" component="div">참조자</Typography>
        <Divider sx={{ my: 1 }} />
        {tech?.refList === undefined || tech?.refList.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="subtitle2" component="div">선택된 참조자가 없습니다.</Typography>
          </Box>
        ) : (
          <TableContainer component={Box}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell>부서명</TableCell>
                  <TableCell>이름</TableCell>
                  <TableCell>직급</TableCell>
                  <TableCell>연락처</TableCell>
                  <TableCell>이메일</TableCell>
                  <TableCell>성별</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tech?.refList.map((usr, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{usr?.dptNm}</TableCell>
                      <TableCell>{usr?.usrNm}</TableCell>
                      <TableCell>{usr?.gradeNm}</TableCell>
                      <TableCell>{usr?.emlAddr}</TableCell>
                      <TableCell>{usr?.telNo}</TableCell>
                      <TableCell>{usr?.gender === 'M' ? '남성' : '여성'}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  )
}

export default TechUsersView